{
  "fr": {
    "appModal": {
      "messages": {
        "confirm": {
          "dirty": "Vous avez des modifications non enregistrées qui seront perdues."
        }
      }
    }
  }
}
